export const GERMAN_LINK = 'https://calendly.com/eversports/user-tests-eversports'
export const ENGLISH_LINK = 'https://calendly.com/d/3wq-bxc-rkz/user-interview-30-min'
